// import "./button.module.css";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
// import Button from "./button";

export const StyledCard = styled.div`
  background-color: ${(props) => props.backgroundColor};
`;
